<template lang="html">
  <div>

    <div class="vx-card nexteventheader_div">
      <div class="vx-card__header">
        <div class="vx-card__title w-full">
          Campaigns
          <feather-icon 
            v-if='false'
            icon="DownloadCloudIcon" 
            svgClasses="w-5 h-5 hover:text-danger stroke-current" 
            class="ml-5" 
            title="Export List"
            @click="activePrompt=true"
          />
          <router-link
            class="mb-2 mr-1 float-right"
            type="filled"
            color="primary"
            :to="{name: 'CampaignCreate'}"
          >
            <vs-button color="primary" type="filled">{{$t('Create')}}</vs-button>
          </router-link>
        </div>
      </div>
    </div>

    <vs-prompt title="Export To Excel" class="export-options" @cancle="clearFields" @accept="exportToExcel" accept-text="Export" @close="clearFields" :active.sync="activePrompt">
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>
    
    <vs-table search max-items="10" pagination :data="campaigns">
      
      <template slot="thead">
        <vs-th sort-key="name">{{ $t("campaign.name") }}</vs-th>
        <vs-th>{{ $t("campaign.no_of_messages") }}</vs-th>
        <vs-th sort-key="campaign_type">{{ $t("campaign.type") }}</vs-th>
        <vs-th>{{ $t("campaign.status") }}</vs-th>
        <vs-th sort-key="started_at">{{ $t("campaign.started_at") }}</vs-th>
        <vs-th sort-key="completed_at">{{ $t("campaign.completed_at") }}</vs-th>
        <vs-th class="testing" colspan="3" >{{ $t("Actions") }}</vs-th>
      </template>

      <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">

            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>
            <vs-td :data="data[indextr].messages_count">
              {{ data[indextr].messages_count }}
            </vs-td>
            <vs-td :data="data[indextr].type">
              <span v-if='data[indextr].type==1'>EMAIL</span>
              <span v-else-if='data[indextr].type==2'>SMS</span>
              <span v-else>-</span>
            </vs-td>
            <vs-td>
              <span v-if="data[indextr].completed_at">{{$t('Completed')}}</span>
              <span v-else-if="data[indextr].is_paused==1">{{$t('Paused')}}</span>
              <span v-else-if="data[indextr].is_paused==0">{{$t('InProgress')}}</span>
              <span v-else>-</span>
            </vs-td>
            <vs-td>{{ data[indextr].started_at | displayDate }}</vs-td>
            <vs-td>{{ data[indextr].completed_at | displayDate }}</vs-td>
            <vs-td :data="data[indextr].id" class="run_btn_action">
                <router-link
                custom
                v-slot="{navigate}"
                :to="{name:'CampaignView', params: {id: data[indextr].id}}"
              >
                <vs-button class="mb-2 mr-1 run_btn" color="primary" type="filled" @click='navigate'>View</vs-button>
              </router-link>
            </vs-td>
          </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { getAll } from '@/api/campaign';

export default {
  components: {
    vSelect
  },
  data: () => ({
    activePrompt: false,
    fileName: '',
    // formats:['xlsx', 'csv', 'txt'],
    formats:['xlsx'],
    cellAutoWidth: true,
    selectedFormat: 'xlsx',
    headerTitle: ['event.name', 'event.topic', 'event.start_date', 'event.end_date', 'event.voting_number', 'event.type', 'OpeningMode'],
    headerVal: ['event_name', 'event_topic', 'event_start_date', 'event_end_date', 'voting_number', 'event_type', 'opening_mode'],
    campaigns: []
  }),
  mounted() {
    this.getAll();
  },
  methods: {
    async getAll() {
      this.$vs.loading();
      try{
        const res = await getAll();
        if(!(res.status==200 && res.data.status=='success'))
          throw res.statusText;
        this.campaigns = res.data.data;
      }catch(error) {
          this.$log.error('File : campaign/index.vue | Function : getAll() | Error :', error);
          this.$vs.notify({
            title: this.$t("FailedToLoadData"),
            text: error,
            color: "danger",
            position: "top-center"
          });
      }
      
      this.$vs.loading.close();
    },
    deleteEvent(id) { 
      this.$swal({
        title: this.$t('event_delete_prompt.title'),
        text: this.$t(''),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes"),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t("No"),
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          this.$vs.loading();
              this.$store
                .dispatch("DeleteEvent",id)
                .then(response => {
                  this.$vs.loading.close();
                  this.$vs.notify({
                    title: this.$t("Success"),
                    text: this.$t('event_delete_prompt.success'),
                    color: "success",
                    position: "top-center"
                  });
                 let indexItem = this.events.findIndex(x => x.id ==id);
                  this.events.splice(indexItem,1);
                })
                .catch(error => {
                  this.$log.error('File : NextEventListing.vue | Function : deleteEvent() | Error :', error);
                  this.$vs.loading.close();
                  // Error response
                  this.$vs.notify({
                    title: this.$t('FailedToLoadData'),
                    text: error,
                    color: "danger",
                    position: "top-center"
                  });
                return false;
                });
          }
      })
    },
    exportToExcel () {
      import('@/utils/Export2Excel').then(excel => {
        const list = this.events
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle.map(t => this.$t(t)),
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    clearFields () {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    }
  }
};
</script>

<style lang="scss">
.nexteventheader_div {
  border-radius: 0 !important;
}
.vx-card__title p{
  font-weight: 600 !important;
  font-size: 1.0rem !important;
  padding-bottom: 10px;
}
.vx-card__header{
  padding: 1.2rem 1.2rem 0 !important;
}
.run_btn{
  padding: 0.5rem 1.1rem !important;
  font-size: 12px;
}
.testing{
  text-align: center;
}
.testing .vs-table-text{
  display: unset;
}
.testertd {
  width: 15%;
  text-align: center;
}
.run_btn_action{
  width: 13%;
}
.actioniconmanage{
  margin-top: 1px;
}
</style>